import { ProjectTemplateModel } from 'api/dto/ProjectTemplate.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'projectTemplate';

export namespace ProjectTemplateState {
  export type Domain = {
    listResource: Resource<ProjectTemplateModel[]>;
    currentResource: Resource<ProjectTemplateModel>;
  };

  export const INITIAL_DOMAIN: Domain = {
    listResource: Resource.createPendingResource(),
    currentResource: Resource.createPendingResource(),
  };
}
